const FormInputCheckboxComponent = ({
  id,
  label,
  name,
  checked,
  onChange,
  isVertical,
  isRequired = false,
  isInLine = false,
}) => {
  const handleChange = (event) => {
    if (onChange) onChange(event.target.checked);
  };
  return (
    <div className="row">
      <div className={isVertical ? "col-sm-12" : "col-sm-5"}>
        {!isInLine && label && (
          <label className="col-form-label" style={{ marginBottom: 5 }}>
            {label}
            {isRequired && <> * </>}
          </label>
        )}
      </div>
      <div
        className={
          isVertical ? "col-sm-12 cursor-pointer" : "col-sm-1 cursor-pointer"
        }
        style={{ marginTop: 6, marginLeft: 20 }}
        onClick={() => onChange(!checked)}
      >
        <input
          id={id || name}
          type="checkbox"
          name={name}
          class="form-check-input"
          checked={checked}
          onChange={handleChange}
        />
        {isInLine && <span style={{ marginLeft: 10 }}>{label}</span>}
      </div>
    </div>
  );
};

export default FormInputCheckboxComponent;
